<template>
  <div class="user">
    <div class="photo">
      <img :src="avatar" alt="avatar" />
    </div>
    <div class="user-info">
      <a
        data-toggle="collapse"
        :aria-expanded="!isClosed"
        @click.stop="toggleMenu"
        @click.capture="clicked"
      >
        <span>
          Administration
          <b class="caret"></b>
        </span>
      </a>

      <collapse-transition>
        <div v-show="!isClosed">
          <ul class="nav">
            <slot>
              <li>
                <a href="#/admin/users">
                  <span class="sidebar-mini">U</span>
                  <span class="sidebar-normal">Users</span>
                </a>
              </li>
              <li>
                <a href="#/admin/drones">
                  <span class="sidebar-mini">D</span>
                  <span class="sidebar-normal">RPAS List</span>
                </a>
              </li>
            </slot>
          </ul>
        </div>
      </collapse-transition>
      <collapse-transition>
        <div v-show="!isClosed">
          <ul class="nav">
            <slot>
              <li>
                <a href="#/admin/radar">
                  <span class="sidebar-mini">RM</span>
                  <span class="sidebar-normal">Radar Map</span>
                </a>
              </li>
            </slot>
          </ul>
        </div>
      </collapse-transition>
    </div>
  </div>
</template>
<script>
import { CollapseTransition } from "vue2-transitions";
import { mapFields } from "vuex-map-fields";

export default {
  components: {
    CollapseTransition
  },
  props: {
    avatar: {
      type: String,
      default: "./img/admin.jpg"
    }
  },
  data() {
    return {
      isClosed: true
    };
  },
  computed: {
    ...mapFields("auth", ["usertype", "plan_type"])
  },
  methods: {
    clicked: function(e) {
      e.preventDefault();
    },
    toggleMenu: function() {
      this.isClosed = !this.isClosed;
    }
  }
};
</script>
<style>
.collapsed {
  transition: opacity 1s;
}
</style>
